export const DEPARTMENT_FACILITY_MAPPING_OPERATOR_DATA_KEY = "departmentFacilityMapping"
